import { render, staticRenderFns } from "./voicemailCell.vue?vue&type=template&id=2ab47116&scoped=true&"
import script from "./voicemailCell.vue?vue&type=script&lang=js&"
export * from "./voicemailCell.vue?vue&type=script&lang=js&"
import style0 from "./voicemailCell.vue?vue&type=style&index=0&id=2ab47116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab47116",
  null
  
)

export default component.exports